export const ORDER_BY_SPLIT_CHAR = '|';
export const SORT_BY_COLUMNS = {
  created_at: 'created_at',
  price: 'price',
} as const;
export const ORDER_OPTIONS = {
  asc: 'asc',
  desc: 'desc',
};
